import { render, staticRenderFns } from "./safeGroupManage.vue?vue&type=template&id=19c9b4a1&scoped=true&"
import script from "./safeGroupManage.vue?vue&type=script&lang=js&"
export * from "./safeGroupManage.vue?vue&type=script&lang=js&"
import style0 from "./safeGroupManage.vue?vue&type=style&index=0&id=19c9b4a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c9b4a1",
  null
  
)

component.options.__file = "safeGroupManage.vue"
export default component.exports